import {View} from "react-native";
import {useGlobalSearchParams, useRouter} from "expo-router";
import ActionButton from "@/lib/components/ActionButton";
import {useChat} from "@/lib/providers/ChatProvider";

export default function ChatHeader() {
    const router = useRouter();

    const {chats} = useChat();
    const {chat_id} = useGlobalSearchParams();
    const currentChat = !!chat_id ? chats.get(chat_id.toString()) : undefined;

    return (
        <View style={{flexDirection: "row", gap: 6}}>
            {currentChat && <ActionButton
                onPress={() => router.push(`/chat/${currentChat.chat.id}/preferences`)}
                height={34}
                border={false}
                icon={"notification"}
            />}
            {currentChat && currentChat.chat.canModerate && <ActionButton
                onPress={() => router.push(`/chat/${currentChat.chat.id}/edit`)}
                height={34}
                border={false}
                icon={"edit"}
            />}
        </View>
    )
}